import {
  checkTeacherProfile,
  getMyTeacherProfile,
  createTeacherProfile,
  updateTeacherProfile,
  deleteTeacherProfile,
  getTeacherById,
  getTeacherByUserId,
  submitTeacherReview,
} from '../api/teacher.api';

export const checkProfile = async () => {
  const res = await checkTeacherProfile();
  return res.data;
};

export const getProfile = async () => {
  const res = await getMyTeacherProfile();
  return res.data;
};

export const createProfile = async (data) => {
  const res = await createTeacherProfile(data);
  return res.data;
};

export const updateProfile = async (id, data) => {
  const res = await updateTeacherProfile(id, data);
  return res.data;
};

export const deleteProfile = async (id) => {
  const res = await deleteTeacherProfile(id);
  return res.data;
};

export const getProfileById = async (id) => {
  const res = await getTeacherById(id);
  return res.data;
};

export const getProfileByUserId = async (userId) => {
  const res = await getTeacherByUserId(userId);
  return res.data;
};

export const submitReview = async (teacherId, data) => {
  const res = await submitTeacherReview(teacherId, data);
  return res.data;
};
